import { Workflow } from '@/app/workflows/actions/interfaces';
import { Description } from './Description';
import { EditDescription } from './EditDescription';
import { EditableComponentWrapper } from './EditableComponentWrapper';

type DescriptionEditableProps = {
  workflow: Workflow;
};

export const DescriptionEditable = ({ workflow }: DescriptionEditableProps) => {
  return (
    <EditableComponentWrapper
      displayComponent={(workflow, onClick) => <Description description={workflow.description} onClick={onClick} />}
      editComponent={({ setIsEdit, workflow }) => (
        <EditDescription defaultName={workflow.description} setIsEdit={setIsEdit} workflow={workflow} />
      )}
      workflow={workflow}
    />
  );
};
